import { render, staticRenderFns } from "./WaterStandardItem.vue?vue&type=template&id=8d72f172&scoped=true&"
import script from "./WaterStandardItem.vue?vue&type=script&lang=js&"
export * from "./WaterStandardItem.vue?vue&type=script&lang=js&"
import style0 from "./WaterStandardItem.vue?vue&type=style&index=0&id=8d72f172&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d72f172",
  null
  
)

export default component.exports